module.exports = __webpack_public_path__ + "static/media/samsung-aife-2021-remote-3.ce3e07fd.webp";